export default "__VITE_ASSET__9cdedaea__"